"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="call-to-action" ref={sectionRef} className="relative w-full bg-dark-section text-dark-foreground py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section via-dark-section to-primary/5 pointer-events-none" />
      
      <div className={`relative z-10 container mx-auto px-6 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-[42px] md:text-[56px] leading-[1.15] font-bold tracking-[-0.3px] text-white mb-6 max-w-4xl mx-auto">
          Ready to Transform Your Business?
        </h2>
        
        <p className="text-[18px] md:text-[20px] leading-[1.7] text-white/85 mb-10 max-w-2xl mx-auto">
          Join thousands of businesses that trust us to deliver exceptional results. Let's start your journey today.
        </p>
        
        <div className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="#">
            <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-200 ease-out px-8 py-6 text-[17px] font-semibold rounded-full min-w-[200px]">
              Get Started Now
            </Button>
          </Link>
          
          <Link to="#">
            <Button variant="outline" size="lg" className="bg-white/10 text-white border-white/30 hover:bg-white/20 hover:border-white/50 shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-200 ease-out px-8 py-6 text-[17px] font-semibold rounded-full min-w-[200px] backdrop-blur-sm">
              Learn More
            </Button>
          </Link>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
    </section>;
}